module.exports = __webpack_public_path__ + "static/media/atozSmile.026f68f1.png";